import React from 'react';
import { SparkProjectResource } from '../types/sparkTypes';
import styles from '../styles/DeepResearchDisplayCard.module.css';
import parentStyles from '../styles/ProjectInsightsWallPanel.module.css'; // For button styles

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { DeleteIcon } from './icons/DeleteIcon'; // Import DeleteIcon

interface DeepResearchDisplayCardProps {
  resource: SparkProjectResource;
  onOpenRemoveConfirm: (resourceFqn: string | null, jobFqn: string | null, resourceTitle: string) => void;
  onViewArticle: (resourceFqn: string) => void;
}

const DeepResearchDisplayCard: React.FC<DeepResearchDisplayCardProps> = (
  { resource, onOpenRemoveConfirm, onViewArticle }
) => {
  const displayName = resource.fsq_title || resource.title || resource.fqn || 'Deep Research Resource';
  const commentText = resource.fsq_question || resource.comment || 'No comment available.';
  const canRemove = !!resource.fqn || !!resource.job_fqn;
  const canView = !!resource.fqn;
  const isFailed = resource.is_failed;
  // Only processing when not ready and not failed
  const isProcessing = !resource.is_ready && !isFailed;

  const handleCardClick = () => {
    // Deep research cards typically contain an article view
    if ((isProcessing || isFailed) || !canView) return;
    onViewArticle(resource.fqn!);
  };

  const handleRemoveClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation(); // Prevent card click
    if (canRemove) {
      onOpenRemoveConfirm(resource.fqn ?? null, resource.job_fqn ?? null, displayName);
    }
  };
  return (
    <li
      className={`${styles.cardContainer} ${isProcessing ? styles.processingAnimation : ''}`}
      onClick={handleCardClick}
      title={isProcessing ? 'Processing...' : `View ${displayName}`}
    >
      {/* Show failure badge if resource failed */}
      {isFailed && (
        <span className={styles.failureBadge}>
          <ErrorOutlineIcon className={styles.failureIcon} fontSize="small" />
          Failed
        </span>
      )}
      <div className={styles.contentContainer}>
        <h3 className={styles.title}>{displayName}</h3>
        <p className={styles.comment}>{commentText}</p>
        {/* Show processing status directly below title */}
        {isProcessing && (
          <span className={styles.processingStatusText}>Processing...</span>
        )}
        {/* <div className={`${parentStyles.sourceBadge} ${styles.sourceBadge}`}>
          <span className={parentStyles.sourceBadgeIcon}><DeepSightsIcon fontSize="small" /></span>
          <span className={parentStyles.sourceBadgeText}>DeepSights Research</span>
        </div> */}
      </div>

      {/* Action buttons (visible on hover via CSS) */}
      <div className={styles.actionsContainer}>
        <button
          className={`${parentStyles.textButton} ${parentStyles.removeButton}`}
          onClick={handleRemoveClick}
          title={`Remove ${displayName}`}
          disabled={!canRemove}
        >
          <DeleteIcon style={{ fontSize: '16px' }} />
        </button>
      </div>
    </li>
  );
};

export default DeepResearchDisplayCard;
